// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-message[data-v-1415e13d] {\n  color: red;\n  font-size: 14px;\n  margin-top: 10px;\n  margin-left: 12px;\n}", ""]);
// Exports
module.exports = exports;
